import { Row, Col, Card, Table, DatePicker, Tag } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function LastProducts({ data, loading, isShow = true }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const columns = [
    {
      title: "TEAM NAME / LEADER NAME",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "User Type",
      dataIndex: "requester",
      render: (_, { requester }) => {
        if (!requester) return "-";
        return requester.type === "master_facilitator" ? "MF" : "CP";
      },
    },
    {
      title: "Requester Name",
      dataIndex: "requester",
      render: (_, { requester }) => {
        if (!requester) return "-";
        return <div>{requester.name || "-"}</div>;
      },
    },

    //   {
    //   title: "User Type",
    //   dataIndex: "requester",
    //     render: (_, {requester}) => {
    //     return requester.type === "master_facilitator" ? "MF" : "CP";
    //   },
    // },
    //   {
    //   title: "Requester Name",
    //   dataIndex: "requester",
    //   render: (_,{requester}) => {
    //      return <div>{requester.name}</div>;
    //    },
    // },
    {
      title: "Generated Date",
      key: "dateGenerated",
      dataIndex: "dateGenerated",
      render: (_, { dateGenerated }) => {
        return new Date(dateGenerated).toLocaleDateString();
      },
    },
    ...(isShow ? [{
      title: "Survey Type",
      dataIndex: "report",
      key: "report",
    }] : []),
    //  {
    //    title: "STATUS",
    //    key: "isActive",

    //    render: (_, { is_deleted, isActive, _id }) => {
    //      let color = is_deleted ? "red" : isActive ? "green" : "red";
    //      return (
    //        <Tag
    //          color={color}
    //          key={isActive}
    //        >
    //          {is_deleted ? "DELETED" : isActive ? "Open" : "Closed"}
    //        </Tag>
    //      );
    //    },
    //  },
    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LastProducts;
